import { BLOCKQUOTS } from "../../../../Data/UiKit/Typography";
import { BlockQuotes, Footer, P } from "../../../../AbstractElements";

export const DynamicBlockquotes = () => {
  return (
    <>
      {BLOCKQUOTS.map(({ text, name, className }, index) => (
        <figure className={`text-${className} d-block dark-blockquote`} key={index}>
          <BlockQuotes className="light-card mb-2">
            <P className="mb-0 txt-primary">{text}</P>
            <Footer className="blockquote-footer pt-3">{name}</Footer>
          </BlockQuotes>
        </figure>
      ))}
    </>
  );
};
